module.exports = __webpack_public_path__ + "img/mind_icon_number_3.e987c4a5.png";